import React, { useEffect, useRef, useState } from "react";
import MemoTemplate from "./MemoTemplate";

export default function ScaledMemo({ memo, full }: { memo: any; full?: boolean }) {
  const outer = useRef<HTMLDivElement>(null);
  const inner = useRef<HTMLDivElement>(null);
  const [w, setW] = useState(794);
  const [h, setH] = useState(1123);

  useEffect(() => {
    const ro = new ResizeObserver(() => {
      if (outer.current) setW(outer.current.clientWidth);
      if (inner.current) setH(inner.current.offsetHeight);
    });
    if (outer.current) ro.observe(outer.current);
    if (inner.current) ro.observe(inner.current);
    return () => ro.disconnect();
  }, []);

  const s = full ? 1 : Math.min(1, w / 794);
  return (
    <div ref={outer} className="w-full">
      <div className="memo-scaler mx-auto" style={{ width: 794 * s, height: h * s }}>
        <div ref={inner} className="memo-scaler print-area shadow-xl" style={{ width: 794, transform: `scale(${s})`, transformOrigin: "top left" }}>
          <MemoTemplate memo={memo} />
        </div>
      </div>
    </div>
  );
}
